import {Directive, HostListener, Input} from '@angular/core';

import {UIDialogService} from 'app/ui/dialog/dialog.service';

import {RequestConfirmationComponent} from './request-confirmation.component';

@Directive({
    selector: '[requestConfirmation]'
})
export class RequestConfirmationDirective {

    private _enabled = true;

    @Input()
    set requestConfirmation(enabled: boolean) {
        this._enabled = enabled || enabled === undefined;
    }

    constructor(private _dialogService: UIDialogService) {
    }

    @HostListener('click')
    private _onClick() {
        if (this._enabled) {
            this._dialogService.open(RequestConfirmationComponent);
        }
    }
}

